
import React, { useEffect } from "react";
import Translate from "../components/Translate";
import { useTranslation } from "react-i18next";
import { updateMetaTags } from "../utils/seo";
import PageBanner from "../components/PageBanner";
import GrievanceFormBase from "../components/GrievanceFormBase";

export default function FeedbackPage() {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        updateMetaTags(
            `${t('feedback')} | ${t('site-title')}`,
            t('feedback-desc'),
            t('feedback-keywords')
        );
    }, [t, i18n.language]);

    return (
        <section className="w-full min-h-screen bg-primary-50/30 pb-16">
            <PageBanner
                title={<Translate text={'feedback'} />}
                subtitle={<Translate text={'feedback-subtitle'} />}
                badgeText={t('badge-your-input-matters')}
            />

            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-[15px]">
                <div className="bg-white rounded-xl shadow-md border border-primary-100 p-8">
                    <h2 className="text-2xl font-bold text-primary-700 mb-6 border-b pb-2">{t('feedback-h1')}</h2>
                    <div className="space-y-6 text-gray-700 leading-relaxed text-left">
                        <section className="mb-8">
                            <p className="text-gray-700 leading-relaxed italic border-l-4 border-primary-500 pl-4 bg-primary-50/30 py-2">
                                {t('feedback-s1-content')}
                            </p>
                        </section>
                    </div>
                </div>

                <div className="mt-12 text-center">
                    <GrievanceFormBase />
                </div>
            </div>
        </section>
    );
}
